/* eslint-disable */

import { useEffect, useState } from "react";
import type { SearchResult } from "algoliasearch/lite";
import { combineIndexHits } from "../components/client/SiteNavigation/NavSearch/NavSearchMethods";
import profile from "@/profiles/profileSingleton";
const algoliaAppId = profile.NEXT_PUBLIC_ALGOLIA_APP_ID || "";
const algoliaAPIKey = profile.NEXT_PUBLIC_ALGOLIA_API_KEY || "";
const charactersToSearch = profile.NEXT_PUBLIC_ALGOLIA_SEARCH_START_ON_THIS_MANY_CHARACTERS ? parseInt(profile.NEXT_PUBLIC_ALGOLIA_SEARCH_START_ON_THIS_MANY_CHARACTERS) : 2;
const useSearchClient = (jobSearch = false) => {
  const [searchClient, setSearchClient] = useState<any>(null);
  const [combinedNbHits, setCombinedNbHits] = useState(0);
  const [results, setResults] = useState<any>(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  useEffect(() => {
    let cancelled = false;
    if (!algoliaAppId || !algoliaAPIKey) {
      setSearchClient(null);
      return;
    }
    import("algoliasearch/lite").then(({
      liteClient
    }) => {
      if (cancelled) return;
      const algoliaClient = liteClient(algoliaAppId, algoliaAPIKey);
      const client = {
        ...algoliaClient,
        async search(requests: any) {
          const emptyResult = {
            results: requests?.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              exhaustiveNbHits: false,
              query: "",
              params: ""
            }))
          };
          try {
            const emptySearch = requests.every(({
              params
            }: {
              params: any;
            }) => !params.query);
            const lessThanCharactersToSearch = requests[1]?.params?.query?.length < charactersToSearch;
            const dontSendResults = (emptySearch || lessThanCharactersToSearch) && !jobSearch;
            if (dontSendResults) {
              return Promise.resolve(emptyResult);
            }
            const searchResults = await algoliaClient.search<SearchResult<any>>(requests);
            setResults(searchResults);
            const {
              parsedNbHits
            } = combineIndexHits(searchResults);
            if (searchResults?.results?.[1]) {
              const resultsArray = searchResults.results[1] as any;
              setCurrentPageNumber(resultsArray?.page + 1);
              if (resultsArray?.facets) {
                if (resultsArray?.facets?.jobType) {
                  const jobTypeKeys = Object.keys(resultsArray.facets.jobType);
                  const jobTypePlaceholder = jobTypeKeys.find(jobType => jobType.includes("placeholder"));
                  if (jobTypePlaceholder) {
                    delete resultsArray.facets.jobType[jobTypePlaceholder];
                  }
                  if (resultsArray.facets.jobCategory) {
                    const categoriesKeys = Object.keys(resultsArray.facets.jobCategory);
                    const categoriesPlaceholder = categoriesKeys.find(category => category.includes("placeholder"));
                    if (categoriesPlaceholder) {
                      delete resultsArray.facets.jobCategory[categoriesPlaceholder];
                    }
                  }
                  if (resultsArray.facets.location) {
                    const locationKeys = Object.keys(resultsArray.facets.location);
                    const locationPlaceholder = locationKeys.find(location => location.includes("placeholder"));
                    if (locationPlaceholder) {
                      delete resultsArray.facets.location[locationPlaceholder];
                    }
                  }
                }
              }
            }
            setCombinedNbHits(parsedNbHits);
            return searchResults;
          } catch (e) {
            console.error(e);
            return emptyResult;
          }
        }
      };
      setSearchClient(client);
    });
    return () => {
      cancelled = true;
    };
  }, [jobSearch]);
  return {
    searchClient,
    combinedNbHits,
    results,
    currentPageNumber
  };
};
export default useSearchClient;